import { render } from "./EquipeBars.vue?vue&type=template&id=6d42637f&scoped=true"
import script from "./EquipeBars.vue?vue&type=script&lang=js"
export * from "./EquipeBars.vue?vue&type=script&lang=js"

import "./EquipeBars.vue?vue&type=style&index=0&id=6d42637f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d42637f"]])

export default __exports__